import { PatternFormat } from "react-number-format";
import { TextField } from "@mui/material";
import withNumberFormatValidate from "./internal/withNumberFormatValidate";

function NumberPatternField(props) {
  return <PatternFormat {...props} customInput={TextField} valueIsNumericString />;
}

export default withNumberFormatValidate(NumberPatternField);
